export default __webpack_public_path__ + "static/media/shirt6.19bcd678.jpeg";